<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />

    <b-card class="bCardGlobal">
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span><b-icon icon="people-fill" aria-hidden="true"></b-icon></span>
          <span>COMISIONES ESPECIALISTA</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>Crud_Bloque</div>
        </b-col>
      </b-row>

      <div class="divSubtitulo">
        <p class="textSubtitulo">
          Configuración de bloque comisiones especialista
        </p>
      </div>

      <b-row>
        <b-col>
            <b-row align-v="center" align-h="end">
              <b-col>
                <b-form-group align="left">
                  <label >Palabra clave</label>
                  <b-input-group size="sm" class="mb-2" id="nombreBusq" lab>
                    <b-input-group-prepend is-text>
                      <b-icon icon="menu-button-wide"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input name="nombre" placeholder="Nombre de la especialidad"
                                  v-model="filtro.palabraClave" @keydown.enter.native="obtenerCatalogoBloques"
                    ></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <b-col></b-col>

              <b-col align="right">
                <b-button v-b-tooltip.hover
                          title="Agregar nuevo bloque" variant="outline-primary"
                          @click="abrirModal()"
                          v-if="$localStorageService.can('Bloque_crear')"
                >Nuevo bloque
                </b-button>
              </b-col>

            </b-row>
        </b-col>
      </b-row>

      <!--   Tabla   -->

      <b-row>
        <b-col cols="12">
          <b-table
            id="Pendientes"
            thead-tr-class="columnas"
            :items="datosTabla"
            :fields="fields"
            :per-page="registrosPorPagina"
            :current-page="paginaActual"
            responsive="true"
            class="parrafos mt-4"
            fixed
          >
            <template v-slot:cell(registroActivo)="row">
              {{ row.item.registroActivo ? "Activo" : "Inactivo" }}
            </template>

            <template v-slot:cell(Acciones)="row">
              <b-button-group>
                <b-button v-if="row.item.registroActivo"
                  title="Modificar Tipo de Solicitud"
                  size="sm"
                  variant="outline-warning"
                  @click="modificar(row.item)"
                  ><em class="fa fa-pencil"></em
                ></b-button>
                <b-button
                  v-if="!row.item.registroActivo && $localStorageService.can('Bloque_editar')"
                  title="Activar tipo solicitud"
                  variant="outline-success"
                  size="sm"
                  @click="activarDesactivarBloque(row.item)"
                  ><em class="fa fa-undo"></em
                ></b-button>
                <b-button
                  v-else-if="$localStorageService.can('Bloque_activar')"
                  title="Desactivar tipo solicitud"
                  variant="outline-danger"
                  size="sm"
                  @click="activarDesactivarBloque(row.item)"
                >
                  <b-icon icon="trash-fill"></b-icon>
                </b-button>
              </b-button-group>
            </template>
          </b-table>
          <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loader">
            <b-alert v-if="datosTabla.length === 0" variant="info" show
              >No hay datos</b-alert
            >
          </b-col>
          <b-col v-if="!loader">
            <b-pagination
              v-if="datosTabla !== undefined && datosTabla.length > 10"
              align="center"
              v-model="paginaActual"
              :total-rows="datosTabla.length"
              :per-page="registrosPorPagina"
              aria-controls="my-table1"
            ></b-pagination>
          </b-col>
        </b-col>
      </b-row>
    </b-card>
  

    <!--  Modal  -->
    <b-modal
      v-model="modalAgregarBloque"
      :title="tituloModal"
      size="xl"
      scrollable
      no-close-on-backdrop
      >
      <b-card no-body>
        <b-tabs >
          <!-- Render Tabs, supply a unique `key` to each tab -->
          <b-tab title="Bloque especialista" active>
            <b-row class="mt-2">
              <b-col>
                <p style="color: #17a2b8; font-weight: 600">Productividad</p>
               <!--  {{especialidadArrayOrigen}}
                {{bloques.nombreEspecialidad}} -->
                <b-form-group align="left">
                  <label for="nombre">Especialidad </label>
                  <v-select
                    :options="especialidades"
                    :reduce="(esp) => esp.idEspecialidad"
                    label="nombreEspecialidad"
                    v-model="bloques.nombreEspecialidad"
                    required
                  />
                  <b-form-invalid-feedback
                    :state="bloques.nombreEspecialidad != null"
                  >
                    Se debe seleccionar la especialidad
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
              <b-col>
                <div style="margin-top: 40px">
                  <b-form-group align="left">
                    <label for="nombre">Duración del bloque (hrs) </label>
                    <b-input-group size="sm" class="mb-2">
                      <b-form-input
                        id="idNombre"
                        placeholder="Duración del bloque (hrs)"
                        type="number"
                        v-model="bloques.duracionBloque"
                        @keydown="decimalesKeydown($event)" 
                        @paste="onPaste"
                        required
                      ></b-form-input>
                      <b-form-invalid-feedback
                        :state="bloques.duracionBloque != null"
                      >
                        Se debe ingresar la duración del bloque
                      </b-form-invalid-feedback>
                    </b-input-group>
                  </b-form-group>
                </div>
              </b-col>

            </b-row>
            <b-table
              responsive
              striped
              hover
              :items="arrayZonas"
              :fields="fieldsZonas"
              thead-tr-class="columnas"
              v-bind="arrayZonas"
              v-if="aplicaTodasZonas == false"
              style="margin-top: 2%"
            >
              <template #cell(nombreZona)="data">
                {{ data.value }}
              </template>
  
              <template v-slot:cell()="{ item, field: { key } }">
                <span v-if="key == 'precio'">
                  <b-form-input
                    v-model="item[key]"
                    :min="1"
                    step="1"
                    type="number"
                    @keydown="filterKey"
                    @input="filterInput"
                  ></b-form-input>
                </span>
  
                <span v-else-if="key == 'precioExtranjero'">
                  <b-form-input
                    v-model="item[key]"
                    :min="0"
                    step="1"
                    type="number"
                    @keydown="filterKey"
                    @input="filterInput"
                  ></b-form-input>
                </span>
  
                <span v-else>
                  <b-form-input
                    v-model="item[key]"
                    :min="0"
                    step="0.01"
                    type="number"
                    @input="isDecimalValue(arrayZonas.indexOf(item), $event)"
                    @paste="onPaste"
                   
                  ></b-form-input>
<!--                   @keydown="decimalesKeydown($event)" 
 -->                  <b-form-invalid-feedback
                    v-if="key == 'productividadMeta'"
                    :state="item[key] != null"
                  >
                    Se debe ingresar la productividad meta
                  </b-form-invalid-feedback>
                  <b-form-invalid-feedback
                    v-if="key == 'pagoGarantizado'"
                    :state="item[key] != null"
                  >
                    Se debe ingresar el pago garantizado
                  </b-form-invalid-feedback>
                  <b-form-invalid-feedback
                    v-if="key == 'bonoDesempeno'"
                    :state="item[key] != null"
                  >
                    Se debe ingresar el bono por desempeño
                  </b-form-invalid-feedback>
                </span>
              </template>
            </b-table>
          </b-tab>
          <b-tab class="p-3" v-for="(i,index) in tabs" :key="'dyn-tab-' + i" :title="'Banda ' + (index+1) ">
            <div class="d-flex justify-content-end">
              <b-button size="sm" variant="info" class="mr-3" @click="limpiarTab(i,index)">
                Limpiar campos
              </b-button>
              <b-button size="sm" variant="secondary" class="float-right" @click="closeTab(i,index)">
                Eliminar banda
              </b-button>
            </div>
            <b-table
            responsive
            striped
            hover
            :items="arrayBandas[index]"
            :fields="bandaZonas"
            thead-tr-class="columnas"
            v-bind="arrayBandas[index]"
            v-if="aplicaTodasZonas == false"
            style="margin-top: 2%"
          >
          
          <template #cell(idPrecio)="data">
            {{ data.value }}
          </template>
            <template #cell(nombreZona)="data">
              {{ data.value }}
            </template>

            <template v-slot:cell()="{ item, field: { key } }">
             
              <span>
                <b-form-input
                  v-model="item[key]"
                  :min="0"
                  step="1"
                  type="number"
                  @keydown="decimalesKeydown($event)" 
                        @paste="onPaste"
                ></b-form-input>
          
              </span>
            </template>
          </b-table>
            
          </b-tab>
  
          <!-- New Tab Button (Using tabs-end slot) -->
          <template #tabs-end>
            <b-nav-item role="presentation" @click.prevent="newTab" href="#">Agregar banda</b-nav-item>
          </template>
  
          <!-- Render this if no tabs -->
          <template #empty>
            <div class="text-center text-muted">
              There are no open tabs<br>
              Open a new tab using the <b>+</b> button above.
            </div>
          </template>
        </b-tabs>
      </b-card>
 <!--      <b-tabs>
        <b-tab title="Bloque especialista" active>
         
        </b-tab>
        <b-tab title="Bandas">
          <b-button @click="agregarBanda()">Agregar nueva banda</b-button>
          <div class="m-4 ml-5" v-for="(banda, index) in bandas" :key="index">
            <button v-if="index > 0" @click="eliminarBanda(index)">elim</button>
            <b-input-group size="sm" class="mb-2">
              <b-form-input
                id="idNombre"
                placeholder="Monto de la banda"
                type="number"
                v-model="banda.montoBanda"
                required
              ></b-form-input>
              <b-form-invalid-feedback :state="banda.montoBanda != null">
                Se debe ingresar el monto de la banda
              </b-form-invalid-feedback>
            </b-input-group>
          </div>
        </b-tab>
      </b-tabs> -->

      <template v-slot:modal-footer>
        <b-button
          variant="outline-info"
          @click="guardarBloques(null)"
          :disabled="loaderAcciones"
        >
          <span v-if="!loaderAcciones">Guardar</span>
          <span v-if="loaderAcciones">
            <b-spinner small></b-spinner>
            Cargando...
          </span>
        </b-button>
        <b-button
          variant="outline-secondary"
          :disabled="loaderAcciones"
          @click="cerrarModal()"
          >Cancelar</b-button
        >
      </template>
    </b-modal>
  </div>
</template>

<script>
import Header from "@/components/Header";
import { required } from "vuelidate/lib/validators";
export default {
  name: "ConfiguracionComisionesEspecialista",
  components: { Header },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    especialidadArrayOrigen: [],
    arrayZonaTodas: [
      {
        bonoIndividualOg: null,
        bonoTrimestral: null,
        comisionBaseEspecialistas: null,
        comisionBaseOG: null,
        comisionMasBonoEspecialistas: null,
        idZona: 10,
        precio: null,
        precioExtranjero: null,
        registroActivo: true,
        nombreZona: "TODAS",
      },
    ],
    arrayZonas: [], //ZONAS
    arrayBandas: [],
    aplicaTodasZonas: false,
    bandaZonas: [
    {
        key: "idPrecio",
        label: "Número de zona",
      },
    {
        key: "nombreZona",
        label: "Zona",
      },
      {
        key: "montoZona",
        label: "Monto de banda por zona",
      },
    ],
    fieldsZonas: [
      {
        key: "nombreZona",
        label: "Zona",
      },

      {
        key: "productividadMeta",
        label: "Productividad meta para bono",
      },
      {
        key: "productividadMaxima",
        label: "Productividad máxima",
      }, ////////REvisar en base de datos hay que hacer el cambio por nueva columna
     /* {
        key: "productividadObjetivo",
        label: "Productividad máxima para bono",
      },*/
      {
        key: "pagoGarantizado",
        label: "Pago garantizado",
      },
      {
        key: "bonoDesempeno",
        label: "Bono desempeño por tx",
      },
    ],
    filtro: {
      id: null,
      palabraClave: null,
      registroActivo: null,
    },
    datosTabla: [],

    tituloModal: "",
    show: false,
    modalAgregarBloque: false,
    loader: false,
    fields: [
      { key: "idBloque", label: "ID", sortable: true },
      { key: "especialidad", label: "Especialidad", sortable: true },
      { key: "duracionHoras", label: "Horas por bloque", sortable: true },
      { key: "fechaAlta", label: "Fecha alta", sortable: true },
      { key: "fechaModificacion", label: "Fecha modificación", sortable: true },
      { key: "usrAlta", label: "Usuario alta", sortable: true },
      { key: "usrModificacion", label: "Usuario modificación", sortable: true },
      { key: "registroActivo", label: "Activar / Desactivar", sortable: true },
      "Acciones",
    ],
    registrosPorPagina: 10,
    paginaActual: 0,
    colores: [],
    tiposSolicitud: [],
    loaderAcciones: false,
    datosGuardar: {
      idEstatusListaEspera: null,
      nombreEstatus: null,
      //proximaCita: true,
      slaMinimo: null,
      slaMaximo: null,
      idColor: 0,
      //registroActivo: true,
    },
    slaInicialValidacion: false,
    bloques: {
      idBloque: null,
      especialidad: null,
      duracionBloque: null,
      productividadMaxima: null,
    },
    tabs: [],
    tabCounter: 0,
    especialidades: null,
    bandas: [{ idBanda: null, montoBanda: null }],
    blnHayMenosPrecio: false,
    faltanDatosDetalle: false,
    metaMayorAMaxima: false
  }),
  validations: {
    datosGuardar: {
      nombreEstatus: { required },
      slaMinimo: { required },
      slaMaximo: { required },
      idColor: { required },
    },
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.llenarZonas();
    this.obtenerCatalogoBloques();
    this.obtenerCatalogoEspecialidades();
  },
  watch: {},
  methods: {
    isDecimalValue(index, valor){
      var RE = /^\d*(\.\d{1})?\d{0}$/;
    if (!RE.test(valor)) {
      this.arrayZonas[index].esValido = false
        this.$swal.fire({
            icon: "warning",
            title: "Aviso",
            text: "Los campos no pueden tener más de un decimal, por favor, corrija",
          });

    }else{
      this.arrayZonas[index].esValido = true
    }

    },

    onPaste () {
     event.preventDefault()

    },
    decimalesKeydown(e) {
      if (['.','-','e'].includes(e.key)){
   e.preventDefault()
}
    },

    agregarBanda() {
      this.bandas.push({
        idBanda: null,
        montoBanda: null,
      });
    },
    eliminarBanda(index) {
      this.bandas.splice(index, 1);
    },
    filterInput(e) {
      if (e.target != undefined) {
        e.target.value = e.target.value.replace(/[^0-9]+/g, "");
      }
    },
    validacionNullACeros() {
        this.arrayZonas.forEach((zona)=>{
            for (let clave in zona){
              if (zona[clave] === null && ((clave === 'productividadMeta') || (clave === 'pagoGarantizado') || (clave === 'bonoDesempeno'))){
                zona[clave] = 0;
              }
            }
        });


    },
    validacionAlmenosUnPrecio() {
      let infoVacia = this.arrayZonas.filter(zona => parseInt(zona.productividadMaxima) == 0 && (zona.productividadMeta == null) && (parseInt(zona.pagoProductividad) == 0) && (zona.pagoGarantizado == null) && (zona.bonoDesempeno == null));
      if(infoVacia.length == 5){
        this.blnHayMenosPrecio = true;
      }else{
        this.arrayZonas.forEach((zona)=>{
        if (((parseInt(zona.productividadMaxima) > 0) || (zona.productividadMeta != null) || (parseInt(zona.pagoProductividad) > 0) || (zona.pagoGarantizado != null) || (zona.bonoDesempeno != null)) ){
            if(zona.productividadMeta == null || zona.pagoGarantizado == null || zona.bonoDesempeno == null || zona.productividadMeta.length == 0 || zona.pagoGarantizado.length == 0  || zona.bonoDesempeno.length == 0 ){
              this.faltanDatosDetalle = true;
            }
        }

        if (zona.productividadMaxima <= zona. productividadMeta){
          this.metaMayorAMaxima = true;
        }

      });
      }

    },
    filterKey(e) {
      const key = e.key;
      if (key === ".") return e.preventDefault();

      if (key === "e") return e.preventDefault();
    },
    llenarZonas() {
      this.$http
        .get(this.$api + "catalogos/listaPrecios")
        .then((response) => {
          if (response.status === 200) {
            // this.arrayZonas = response.data.data;

            this.arrayZonas = response.data.data.map(function (el) {
              var o = Object.assign({}, el);
              o.productividadMaxima = "0";
              o.productividadMeta = null;
              o.pagoGarantizado = null;
              o.bonoDesempeno = null;
              return o;
            });

            this.arrayZonasBanda = response.data.data.map(function (el) {
              var o = Object.assign({}, el);
              o.montoZona = 0;
              return o;
            });

          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    limpiarTab(x,index) {

      this.arrayBandas[index].forEach(element => {
        element.montoZona = null
      });
    },
    closeTab(x,index) {
      let obj = JSON.parse(JSON.stringify(this.arrayBandas));
      let campoLleno = false;
      for (let i = 0; i < this.tabs.length; i++) {
        if (this.tabs[i] === x) {
          obj[index].forEach(banda => {
          if (banda.montoZona != null && banda.montoZona != '') {
            campoLleno = true;
          }
        });

          if(campoLleno){
            this.$swal.fire({
            icon: "warning",
            title: "Aviso",
            text: "La banda a eliminar no puede contener información, por favor vacíe los campos",
          });
          }else{
            this.tabs.splice(i, 1);
            this.arrayBandas.splice(index,1)

          }

        }
      }
    },
    newTab() {
      this.tabs.push(this.tabCounter++);
      this.arrayBandas.push(JSON.parse(JSON.stringify(this.arrayZonasBanda)))

    },

    slaKeydown(e) {
      if (/^\W$/.test(e.key)) {
        e.preventDefault();
      }
    },
    abrirModal() {

      this.limpiarModal();
      this.tituloModal = "Nuevo bloque";
      this.llenarZonas();
      this.modalAgregarBloque = true;
      this.bandas = [{ idBanda: null, montoBanda: null }];
    },
    obtenerCatalogoEspecialidades() {
      this.loader = true;
      this.$http
        .get(
          this.$api + "comisionBloqueEspecialista/obtenerEspecialidadesBloque"
        )
        .then((respuesta) => {
          if (respuesta.data) {
            this.especialidades = respuesta.data.data;
          }
        })
        .finally(() => {
          this.loader = false;
        });

       /*  this.$http
        .get(this.$api + "catalogos/obtenerEspecialidades")
        .then((response) => {
          if (response.status === 200) {
            var arrayRespuesta = response.data.data.map((it) => {
              return {
                value: it.id,
                text: it.especialidad,
                color: it.color,
                especialidadOrigen: it.especialidadOrigen,
              };
            });

            this.especialidadArrayOrigen = arrayRespuesta.filter(function (
              item
            ) {
              return item.especialidadOrigen;
            });


          }
        })
        .catch((error) => {
          console.error(error);
        }); */
    },

    obtenerCatalogoBloques() {
      this.loader = true;
      this.$http
        .post(
          this.$api +
            "comisionBloqueEspecialista/obtenerTodos?idClinica=" +
            this.$localStorageService.getIdClinica(),this.filtro
        )
        .then((respuesta) => {
          if (respuesta.data) {
            this.datosTabla = respuesta.data.data;
          }
        })
        .finally(() => {
          this.loader = false;
        });
    },

    guardarBloques() {
      this.metaMayorAMaxima = false;
      this.faltanDatosDetalle = false;
        var bandaVacia = false;
        let numeroBanda = [];

      this.validacionAlmenosUnPrecio();
      let datoNoValido = false;
      var RE = /^\d*(\.\d{1})?\d{0}$/;

      let tieneDecimales = this.arrayZonas.filter(zona => !RE.test(Number(zona.productividadMaxima)) || !RE.test(Number(zona.productividadMeta)) || !RE.test(Number(zona.pagoGarantizado)) || !RE.test(Number(zona.bonoDesempeno)));

      this.arrayBandas.forEach((element,index) => {
        const bandaTieneDato = element.filter(banda => banda.montoZona != 0 || banda.montoZona != '')
        if (bandaTieneDato.length == 0) {
          bandaVacia = true
          numeroBanda.push(index+1)
        }
      })

      if (
        this.bloques.nombreEspecialidad == null ||
        this.bloques.duracionBloque == null
      ) {
        datoNoValido = true;
      }

      if (datoNoValido || this.faltanDatosDetalle == true) {
        this.$swal.fire({
          icon: "warning",
          title: "Aviso",
          text: "Por favor llene los datos obligatorios",
        });
      }else if(bandaVacia){
          this.$swal.fire({
                icon: "info",
                title: "Aviso",
                text: "La(s) banda(s) " + (numeroBanda.join(', ')) + " no tiene(n) información, por favor llene los campos o elimine la banda",
              });
        
      }else if(this.blnHayMenosPrecio == true){
          this.$swal.fire({
            icon: "warning",
            title: "Aviso",
            text: "Favor de ingresar al menos un dato en las zonas",
          });
       }else if(tieneDecimales.length > 0){ 
        this.$swal.fire({
            icon: "warning",
            title: "Aviso",
            text: "Los datos no pueden tener más de un decimal, por favor verifique la información",
          });
      
        } else if (this.metaMayorAMaxima){
        const Toast = this.$swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 6000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener('mouseenter', this.$swal.stopTimer)
            toast.addEventListener('mouseleave', this.$swal.resumeTimer)
          }
        })

        Toast.fire({
          icon: 'warning',
          title: 'La productividad máxima no puede ser menor o igual que la productividad meta para bono'
        })

      }      else{
          this.validacionNullACeros(); 
          let bandasFinal = [];
      
       

      this.arrayBandas.forEach((element) => {
        element.forEach(element2 => {
          bandasFinal.push(element2)
          
        });
      });

      
      if (datoNoValido == false && this.blnHayMenosPrecio == false){
        this.loaderAcciones = true;
        let parametros = {
          idBloque: this.bloques.idBloque,
          idEspecialidad: this.bloques.nombreEspecialidad,
          duracionHoras: parseInt(this.bloques.duracionBloque),
          detalleBloque: this.arrayZonas,
          bandas: bandasFinal,
          
        };
        this.$http
          .post(this.$api + "comisionBloqueEspecialista/guardar", parametros)
          .then((respuesta) => {
            if (respuesta.data) {
              this.loaderAcciones = false
              this.$swal.fire({
                icon: "info",
                title: "Aviso",
                text: respuesta.data.data,
              });
            }
            this.cerrarModal();
            this.obtenerCatalogoBloques();
            this.bloques = {
              idBloque: null,
              especialidad: null,
              nombreEspecialidad: null,
              duracionBloque: null,
              productividadMaxima: null,
            };
          });
        this.blnHayMenosPrecio = false;
        
      } 
      }
     
    },

    modificar(item) {
      this.tabs = [];
      this.arrayBandas = [];
      const parametros = {idBloque: item.idBloque}
      this.$http
        .post(
          this.$api +
            "comisionBloqueEspecialista/obtenerDetalle", parametros
        )
        .then((respuesta) => {
          if (respuesta.data.data) {
            this.arrayZonas = respuesta.data.data;
            this.bloques.nombreEspecialidad = item.idEspecialidad;
            this.bloques.duracionBloque = item.duracionHoras;
            this.bloques.productividadMaxima = item.productividadMaxima;
          }
        });

      this.$http
        .post(
          this.$api +
            "comisionBloqueEspecialista/obtenerBandasBloque", parametros
        )
        .then((respuesta) => {
          if (respuesta.data.data) {
            let bandas = respuesta.data.data
            while(bandas.length > 0){
              let array = []

              for (let index = 0; index < 5; index++) {
                array.push(bandas[index])
               
                
              }
              this.tabs.push(this.tabCounter++);
                this.arrayBandas.push(array)
              bandas.splice(0, 5);

      
            }
          }
        });

      this.bloques.idBloque = item.idBloque;
      this.tituloModal = "Modificar bloque";
      this.modalAgregarBloque = true;
      
    },
    activarDesactivarBloque(item) {
      const mensaje = item.registroActivo
        ? "¿Está seguro de desactivar el bloque?"
        : "¿Está seguro de activar el bloque?";
      this.$swal({
        icon: "warning",
        text: mensaje,
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCancelButton: true,
        showConfirmButton: true,
      }).then((aceptar) => {
        if (aceptar.value) {
          const params = {
            idBloque: item.idBloque
          }
          this.$http.put(this.$api + "comisionBloqueEspecialista/activarDesactivarBloque", params)
            .then((respuesta) => {
              if (respuesta.data) {
                item.registroActivo = !item.registroActivo;
                this.$swal.fire({
                  icon: "info",
                  title: "Aviso",
                  text: "El bloque se actualizó correctamente",
                });
              }
            });
        }
      });
    },
    obtenerColores() {
      this.$http
        .get(this.$api + "catalogos/obtener/colores")
        .then((respuesta) => {
          if (respuesta.data.data) {
            this.colores = respuesta.data.data;
          }
        });
    },

    cerrarModal() {
      this.modalAgregarBloque = false;
      this.limpiarModal();
    },

    limpiarModal(){
      
      this.bloques = {
        idBloque: null,
        especialidad: null,
        nombreEspecialidad: null,
        duracionBloque: null,
        productividadMaxima: null,
      };

      this.tabs = [];
      this.arrayBandas = [];
    }
  },
};
</script>

<style scoped>
.bCardGlobal {
  margin: 2% 4% 2% 4%;
  padding: 0.5% 1% 0.5% 1%;
  border-radius: 20px;
}

.divSubtitulo {
  width: 100%;
  margin-top: 2%;
  margin-bottom: 2%;
  border-bottom: 5px solid #8ec6e9;
}

.divInput {
  margin-left: 1%;
  margin-right: 3%;
}

.textSubtitulo {
  color: #093974;
  font-weight: 600;
  font-size: 22px;
  text-align: left;
}

.overflow-ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.scroll-area {
  position: relative;
  margin: auto;
  height: 500px;
}
</style>
